module.exports = __webpack_public_path__ + "media/images/flags/fj-e25ef0590d3a6f7815b410d0323b1108.svg";